import type { AssetType, ReportType } from '~/types';
import StyledIconTextPair from './StyledIconTextPair';
import { iconFromAssetType } from './util';

const LearningObjectIconTextPair = ({
  type,
  text,
  subtext,
  href = null,
  isActive = false,
  isHidden = false,
  onPress,
}: {
  type: AssetType | ReportType;
  text: string;
  subtext?: string;
  href?: string;
  isActive?: boolean;
  isHidden?: boolean;
  onPress?: () => void;
}) => {
  const lowercaseType = type.toLowerCase();

  return (
    <StyledIconTextPair
      type={type}
      icon={iconFromAssetType(lowercaseType)}
      text={text}
      subtext={subtext}
      href={href}
      isActive={isActive}
      isHidden={isHidden}
      onPress={onPress}
    />
  );
};

export default LearningObjectIconTextPair;
